<template>
  <div class="login__content-wrap">
    <h2 class="login__section-title">
      Welcome back!
    </h2>
    <form v-on:submit.prevent="logIn">
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label for="email" class="input-group__label">Email Address</label>
        <input
          id="email"
          class="input-group__input input-group__input--wide"
          :class="{
            'input-group__input--error': $v.email.$invalid && $v.email.$dirty,
          }"
          v-model="email"
          aria-required="true"
          :aria-invalid="$v.email.$invalid && $v.email.$dirty"
        />
        <div
          class="input-group__error"
          v-if="!$v.email.required && $v.email.$dirty"
          role="alert"
        >
          Please enter an email address
        </div>
        <div
          class="input-group__error"
          v-if="!$v.email.email && $v.email.$dirty"
          role="alert"
        >
          Please enter a valid email
        </div>
      </div>
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label for="password" class="input-group__label">Password</label>
        <input
          id="password"
          :type="hidePassword ? 'password' : 'text'"
          class="input-group__input input-group__input--wide"
          :class="{
            'input-group__input--error':
              $v.password.$invalid && $v.password.$dirty,
          }"
          v-model="password"
          aria-required="true"
          :aria-invalid="$v.password.$invalid && $v.password.$dirty"
        />
        <DisclosureButton
          :hideAction="toggleHidePassword"
          :showAction="toggleShowPassword"
          :hide="hidePassword"
          target="password"
        />
        <div
          class="input-group__error"
          v-if="!$v.password.required && $v.password.$dirty"
          role="alert"
        >
          Please enter a password
        </div>
      </div>
      <LoadingButton
        type="submit"
        wide
        big
        class="layout--margin-top-xs layout--margin-bottom-md"
        :event="logIn"
        :loading="$wait.is('logging in')"
        label="Log in"
        loadingLabel="Logging in..."
      />
      <div class="input-group__error" v-if="error" role="alert">
        Error logging in. Please check your username and password and try again.
      </div>
      <router-link
        class="link layout--margin-top-sm layout--margin-bottom-md"
        :to="{ name: 'forgot password' }"
        >Forgot Password?</router-link
      >
      <p>
        Need an account?
        <router-link
          class="link layout--margin-top-sm layout--margin-bottom-md"
          :to="{ name: 'register' }"
          >Sign up</router-link
        >
      </p>
    </form>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import { mapWaitingActions } from "vue-wait";

import LoadingButton from "../../components/LoadingButton";
import DisclosureButton from "../../components/DisclosureButton";

export default {
  name: "login-form",
  components: {
    LoadingButton,
    DisclosureButton,
  },
  data() {
    return {
      email: "",
      password: "",
      submitStatus: "",
      hidePassword: true,
      error: false,
    };
  },
  methods: {
    ...mapActions("session", ["logUserIn", "clearSession"]),
    ...mapWaitingActions("session", { logUserIn: "logging in" }),
    logIn: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.logUserIn({ email: this.email, password: this.password })
          .then(status => {
            this.$v.$reset();
            this.error = false;
            this.$router.push({ name: "dashboard overview" });
          })
          .catch(error => {
            this.$v.$reset();
            this.error = true;
          });
      }
    },
    toggleHidePassword() {
      this.hidePassword = true;
    },
    toggleShowPassword() {
      this.hidePassword = false;
    },
  },
  computed: {
    ...mapGetters("session", ["loggedIn"]),
  },
  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
    },
  },
};
</script>

<style></style>
